function handleCartEvents(event) {
    console.log(event);
    
    function checkButton() {
        const button = document.querySelector('.cd-buy-button');
        if (!button) {
            requestAnimationFrame(checkButton); 
            return;
        }

        button.style.display = 'flex';
        button.style.alignItems = 'center';
        button.style.justifyContent = 'space-between';

        let addText = button.querySelector('.add-text');

        if (!addText) {
            addText = document.createElement('span');
            addText.classList.add('add-text');
            addText.textContent = 'ADD';
            addText.style.display = 'inline';

            const svg = button.querySelector('svg');
            if (svg) {
                button.insertBefore(addText, svg);
            } else {
                button.appendChild(addText);
            }
        } else {
            addText.style.display = 'inline';
        }
    }

    requestAnimationFrame(checkButton);
}

window.addEventListener('OpusCartChange', handleCartEvents);
window.addEventListener('OpusOpenCartState', handleCartEvents);

